// extracted by mini-css-extract-plugin
export var bounce = "_ph-1";
export var generatingText = "_ph-6";
export var lightning = "_ph-4";
export var popup = "_ph-5";
export var progressBar = "_ph-7";
export var progressFill = "_ph-8";
export var progressShimmer = "_ph-9";
export var progressText = "_ph-a";
export var shimmer = "_ph-3";
export var uploadIcon = "_ph-0";
export var uploadingText = "_ph-2";